/**
 * These ids and the `magic-apron-assistant.question-ask` event that carries them are both
 * temporary, standing in until Magic Apron accepts external events and can report the click itself.
 */

/** The id Magic Apron reports when the cookie is missing. */
const FALLBACK_SESSION_ID = 'fallback-sessionId';

/** Off the `thda.s` cookie, so a click here carries the id Magic Apron would report for it. */
export const getSessionId = () => (
  (typeof window !== 'undefined' && window.cookieUtils?.readBrowserCookie('thda.s'))
  || FALLBACK_SESSION_ID
);

/** Identifies a single click. Falls back to a uuid, since a fallback session id is shared. */
export const createActionId = (sessionId) => (
  !sessionId || sessionId === FALLBACK_SESSION_ID
    ? `${crypto.randomUUID()}_${Date.now()}`
    : `${sessionId}_${Date.now()}`
);
